import { Controller } from "@hotwired/stimulus"

// Clickable image → fullscreen overlay.
// Markup:
//   <div data-controller="lightbox">
//     <button data-action="click->lightbox#open">...image...</button>
//     <div data-lightbox-target="overlay" class="hidden ...">...fullsize image...</div>
//   </div>
export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    this.onKey = this.onKey.bind(this)
  }

  open(event) {
    event.preventDefault()
    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")
    document.documentElement.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.onKey)
  }

  close(event) {
    if (event) event.preventDefault()
    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("flex")
    document.documentElement.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.onKey)
  }

  onKey(event) {
    if (event.key === "Escape") this.close()
  }
}
